<div class="button-container">
  <div class="trajet-container">
    <div class="trajet" 
      [ngClass]="{ spinner: !isDataLoaded }" 
      (click)="showItem()"
    >
      <ng-container *ngIf="isDataLoaded; else loading">
        <div class="bars">
          <div
            width="8%"
            data-toggle="tooltip"
            title="{{ parentDetails?.startAddress }}"
          >
            <img
              src="assets/icons/realtime/km-jour/play-button.png"
              class="icon"
              alt="My Icon"
            />
            {{ parentDetails?.startAddress | slice : 0 : 17 }}
            <span *ngIf="parentDetails && parentDetails.startAddress && parentDetails.startAddress.length > 20"> ...</span>
          </div>
          <div
            width="8%"
            style="flex: 1.6;"
          >
            <img
              src="assets/icons/realtime/km-jour/highway.png"
              class="icon"
              alt="My Icon"
            />
            {{ parentDetails?.distanceDriven | number : "1.0-3" }} Km
          </div>
          <div
            width="8%"
            data-toggle="tooltip"
            title="{{ parentDetails?.endAddress }}"
          >
            <img
              src="assets/icons/realtime/km-jour/stop-button.png"
              class="icon"
              alt="My Icon"
            />
            {{ parentDetails?.endAddress | slice : 0 : 17 }}
            <span *ngIf="(parentDetails && parentDetails.endAddress  && parentDetails.startAddress.length > 20)"> ...</span>
          </div>
          <div>
            <img
            src="assets/icons/realtime/km-jour/truck.png"
            class="icon-image"
            alt="My Icon"
            /> {{selectedVehicule?.matricule}}
          </div>
          <div *ngIf="useFms" style="flex: 1.4;">
            <img
            src="assets/icons/realtime/km-jour/gas-station.png"
            class="icon-image"
            alt="My Icon"
            /> {{parentDetails?.usedFuel}} L
          </div>
          <div style="flex: 0.3;"></div>
        </div>
        <div class="bars bar2">
          <div>
            <img
              src="assets/icons/realtime/km-jour/hourglass.png"
              class="watch"
              alt="My Icon"
            />
            {{ (parentDetails ? parentDetails.pathDuration  : 00) | durationSec}}
          </div>
          <div
              style="flex: 1.6;"
            >
            <img
              src="assets/icons/realtime/km-jour/Speed.png"
              class="icon"
              alt="My Icon"
            />
            {{ parentDetails?.maxSpeed }} Km/ H
          </div>
          <div>
            <img
              src="assets/icons/realtime/km-jour/Key.png"
              class="icon"
              alt="My Icon"
            />
            {{ (parentDetails ? parentDetails.stopDuration: 00) | durationSec }}
          </div>
          <div>
            <img
            src="assets/icons/realtime/km-jour/driver.png"
            class="icon-image"
            alt="My Icon"
            /> {{dataManagementService.getDriverName(selectedVehicule.driver) | slice : 0 : 15}}
          </div>
          <div *ngIf="useFms" style="flex: 1.4;">
            <img
            src="assets/icons/realtime/km-jour/gas-pump.png"
            class="icon-image"
            alt="My Icon"
            /> {{calculeConsumation(parentDetails?.fuelConsumption) | number: '1.0-2'}} %
          </div>
                    <div style="flex: 0.3;"></div>
        </div>
        <div class="multiselect-trajets">
          <button
            class="icon-btn multi-select"
            [class.active]="isMultiSelectTrajet"
            (click)="toggleMultiSelect($event)"
            title="Multi-select trajets"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M22 12.999V20C22 20.5523 21.5523 21 21 21H13V12.999H22ZM11 12.999V21H3C2.44772 21 2 20.5523 2 20V12.999H11ZM11 3V10.999H2V4C2 3.44772 2.44772 3 3 3H11ZM21 3C21.5523 3 22 3.44772 22 4V10.999H13V3H21Z"></path></svg>
          </button>
          <button
            class="icon-btn play"
            (click)="playSelected($event)"
            title="Play selected trajets"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M19.376 12.4161L8.77735 19.4818C8.54759 19.635 8.23715 19.5729 8.08397 19.3432C8.02922 19.261 8 19.1645 8 19.0658V4.93433C8 4.65818 8.22386 4.43433 8.5 4.43433C8.59871 4.43433 8.69522 4.46355 8.77735 4.5183L19.376 11.584C19.6057 11.7372 19.6678 12.0477 19.5146 12.2774C19.478 12.3323 19.4309 12.3795 19.376 12.4161Z"></path></svg>
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #loading>
  <div style="padding-bottom: 2px">
    <i class="fa fa-spinner fa-pulse fa-2x fa-fw"></i>
  </div>
</ng-template>
